import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle}</title>
                    <meta name="description" content="The Place Making Institute serves as a long term advocate for community-based design and planning, with programming for education, engagement of public officials and non-profit organizations." />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
